<template>
    <div style="padding-top: 80px">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-magnify</v-icon>
                <p style="color: white;">Búsqueda Queja</p>

            </v-card-title>
            <v-form ref="form">
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col md="12">

                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">No.Queja</span>
                                                <v-text-field v-model="datos.noqueja" outlined dense maxlength="10"
                                                    @keypress="ruleNumber($event, datos.noqueja)">

                                                </v-text-field>
                                            </div>

                                        </v-col>
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Reporte</span>
                                                <v-text-field v-model="datos.reporte" outlined dense maxlength="10"
                                                    @keypress="ruleNumber($event, datos.reporte)">

                                                </v-text-field>
                                            </div>

                                        </v-col>

                                    </v-row>
                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Tipo</span>
                                                <v-select outlined dense :items="tipoArray" v-model="datos.tipo"
                                                    no-data-text="Sin datos" item-text="text" item-value="value"
                                                    placeholder="Seleccione una opción">

                                                </v-select>
                                            </div>

                                        </v-col>

                                    </v-row>
                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Departamento</span>
                                                <v-select outlined dense :items="deptosArray"
                                                    v-model="datos.departamento" no-data-text="Sin datos"
                                                    item-text="dpnombre" item-value="dpid"
                                                    placeholder="Seleccione una opción">

                                                </v-select>
                                            </div>

                                        </v-col>
                                    </v-row>


                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Estado</span>
                                                <v-select outlined dense :items="estadoArray" v-model="datos.estado"
                                                    no-data-text="Seleccione una opción" item-text="text"
                                                    item-value="value" placeholder="Seleccione una opción">

                                                </v-select>
                                            </div>

                                        </v-col>

                                    </v-row>

                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Origen de queja</span>
                                                <v-select outlined dense :items="fuentesArray" v-model="datos.idFuente"
                                                    no-data-text="Sin datos" item-text="ctfConcepto" item-value="ctfid"
                                                    placeholder="Seleccione una opción">
                                                </v-select>
                                            </div>
                                        </v-col>
                                    </v-row>


                                    <v-row>
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Fecha Inicio:</span>
                                                <v-dialog ref="dialog1" outlined v-model="modalIni"
                                                    :return-value.sync="datos.fechaInicio" persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="date-align-center">
                                                            <v-text-field v-model="fechaInicio" label="" readonly
                                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                                        </div>
                                                    </template>
                                                    <v-date-picker v-model="datos.fechaInicio" locale="es-mx"
                                                        scrollable>
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="primary" @click="modalIni = false">
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn text color="primary"
                                                            @click="$refs.dialog1.save(datos.fechaInicio)">
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </div>

                                        </v-col>
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Fecha Fin:</span>
                                                <v-dialog ref="dialog" outlined v-model="modalFin"
                                                    :return-value.sync="datos.fechaFin" persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="date-align-center">
                                                            <v-text-field v-model="fechaFin" label="" readonly
                                                                :disabled="fecIn" outlined dense v-bind="attrs"
                                                                v-on="on"></v-text-field>
                                                        </div>
                                                    </template>
                                                    <v-date-picker v-model="datos.fechaFin" locale="es-mx"
                                                        :min="minDate" scrollable>
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="primary" @click="modalFin = false">
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn text color="primary"
                                                            @click="$refs.dialog.save(datos.fechaFin)">
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </div>

                                        </v-col>
                                    </v-row>



                                </v-col>

                            </v-row>



                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark class="ma-2" color="primary" title="Buscar" @click="buscar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Buscar</span>
                            </v-btn>
                            <v-btn dark class="ma-2" color="#FF4081" title="Limpiar" @click="limpiar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Limpiar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
                <div v-if="showBusqueda">
                    <v-card-text>
                        <v-tooltip bottom v-if="total > 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" class="ma-2" color="green" @click="DescargarExcel()">
                                    <v-icon color="white">
                                        mdi-file-excel-outline
                                    </v-icon>
                                    <span style='color: white;'>Descargar Excel</span>
                                </v-btn>

                            </template>
                            <span>Descargar Excel</span>
                        </v-tooltip>
                        <v-row justify="center">
                            <v-col cols="12">
                                <DataTable :url="urlBusqueda" :columns="columnsBusqueda" :params="datosBusqueda"
                                    @apiDT="apiDT = $event" :formatterActions="formatterActions"
                                    @registro="numeroregistro" :order="[[0, 'desc']]">
                                </DataTable>



                            </v-col>
                        </v-row>



                    </v-card-text>

                </div>

            </v-form>
        </v-card>
    </div>
</template>




<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Quejas from "@/services/Quejas/Quejas.service.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import Menu from '@/components/pages/Quejas/Menu/Menu.vue';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Archivos from '@/services/Archivos/Archivos.service.js';
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable,
    },
    data() {
        return {
            showcargando: false,
            total: 0,
            fecIn: true,
            disabledSave: false,
            deptosArray: [],
            tipoArray: [],
            estadoArray: [],
            minDate: '',
            datos: {
                tipoQueja: '3',
                noqueja: '',
                reporte: '',
                tipo: '',
                departamento: '',
                estado: '',
                fechaInicio: '',
                fechaFin: '',
                idFuente: '',
            },
            datosBusqueda: {
                tipoQueja: '3',
                noqueja: '',
                reporte: '',
                tipo: '',
                departamento: '',
                estado: '',
                fechaInicio: '',
                fechaFin: '',
                idFuente: '',
            },
            tipoArray: [
                {
                    value: "1",
                    text: "Externa"
                },
                {
                    value: "2",
                    text: "Interna"
                }
            ],
            modalIni: false,
            fechaInicio: '',

            modalFin: false,
            fechaFin: '',
            showBusqueda: false,
            urlBusqueda: "Quejas/obtenerBusquedaQuejas",
            columnsBusqueda: [
                { name: 'idQueja', data: 'idQueja', title: "No.Queja" },
                { name: 'reporte', data: 'reporte', title: "Reporte" },
                { name: 'quetipoqueja', data: 'quetipoqueja', title: "Tipo" },
                { name: 'seqtipoSeguimiento', data: 'seqtipoSeguimiento', title: "Estado" },
                { name: 'quenombre', data: 'quenombre', title: "Quejoso" },
                { name: 'dpnombre', data: 'dpnombre', title: "Departamento" },
                { name: 'fnombre', data: 'fnombre', title: "Origen" },
                { name: 'quedescripcion', data: 'quedescripcion', title: "Detalle" },
                { name: 'clnombre', data: 'clnombre', title: "Aseguradora" },
                { name: 'uslogin', data: 'uslogin', title: "Usuario" },
                { name: 'quefecha', data: 'quefecha', title: "Fecha" },
                //{ name: 'prestatus', data: 'prestatus', title: "Detalle" },
                { name: "detalle", data: "detalle", title: "", formatter: [this, "formatearDetalle"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "irDetalleQueja"] },

            ],

            fuentesArray: [],

        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
    },
    watch: {
        'datos.fechaInicio'(val) {
            this.fechaInicio = val;

            if (val != '') {
                this.fecIn = false;
                this.minDate = val;
            }

        },
        'datos.fechaFin'(val) {
            this.fechaFin = val;
        },

    },
    methods: {
        numeroregistro(nombre, total) {
            this.total = total;

        },
        formatearDetalle(x) {
            return `<button type="button" data-action="0" data-params="${x}" class="dt-formatterAction v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small blue" title="Ir a Detalle" style="height: 30px; width: 30px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-eye theme--dark" style="font-size: 20px;"></i></span></button>`;

            //return `<button type="button" data-action="0" data-params="${x}" class="dt-formatterAction ma-2 v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default green" title="Asignar"><span class="v-btn__content"><span style="color: white;">Asignar</span></span></button>`;

        },
        async irDetalleQueja(params, item, fila) {

            var queja = {
                idQueja: item.idQueja,
            };

            await MetodosGenerales.guardarEnSesionInfoReporte(queja, 'quejas');

            this.$router.push({ name: `DetalleQueja` }).catch(error => error);


        },
        async DescargarExcel() {

            this.showcargando = true;
            const response = await Quejas.listadoDescargaExcel(this);
            let today = moment().format('yyyy-MM-DD');

            let nombreArchivo = 'Quejas_ReporteQuejas_General-' + today.toString();

            await MetodosGenerales.exportToExcel(response, nombreArchivo, false, false);



            this.showcargando = false;

            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'QuejasPendientes');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'Mis Pendientes Quejas');
            formData.append("lanombre", nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData).then(data => {
            });

        },
        async buscar() {

            if ((this.datos.noqueja == null || this.datos.noqueja == '')
                && (this.datos.reporte == null || this.datos.reporte == '')
                && (this.datos.tipo == null || this.datos.tipo == '')
                && (this.datos.departamento == null || this.datos.departamento == '')
                && (this.datos.estado == null || this.datos.estado == '')
                && (this.datos.fechaInicio == null || this.datos.fechaInicio == '')
                && (this.datos.fechaFin == null || this.datos.fechaFin == '')
                && (this.datos.idFuente == null || this.datos.idFuente == '')
            ) {
                this.$swal({
                    position: 'center',
                    icon: 'info',
                    title: 'Info',
                    text: 'LLene al menos un dato',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                return;


            }
            else if (this.datos.fechaInicio != '' && this.datos.fechaFin == '') {
                this.$swal({
                    position: 'center',
                    icon: 'info',
                    title: 'Info',
                    text: 'Falta seleccionar la Fecha Fin',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                return;
            }
            else {
                const noqueja = this.datos.noqueja;
                const reporte = this.datos.reporte;
                const tipo = this.datos.tipo;
                const departamento = this.datos.departamento;
                const estado = this.datos.estado;
                const fechaInicio = this.datos.fechaInicio;
                const fechaFin = this.datos.fechaFin;
                const idFuente = this.datos.idFuente;


                this.datosBusqueda.noqueja = noqueja;
                this.datosBusqueda.reporte = reporte;
                this.datosBusqueda.tipo = tipo;
                this.datosBusqueda.departamento = departamento;
                this.datosBusqueda.estado = estado;
                this.datosBusqueda.fechaInicio = fechaInicio;
                this.datosBusqueda.fechaFin = fechaFin;
                this.datosBusqueda.idFuente = idFuente;

                this.showBusqueda = true;
            }


        },
        limpiar() {
            this.$refs.form.reset();
            let today = moment().format('yyyy-MM-DD');

            this.datos.fechaInicio = today;
            this.datos.fechaFin = today;
            this.fechaInicio = today;
            this.fechaFin = today;
            setTimeout(() => {

                this.datos = {
                    tipoQueja: '3',
                    noqueja: '',
                    reporte: '',
                    tipo: '',
                    departamento: '',
                    estado: '',
                    fechaInicio: '',
                    fechaFin: '',
                    idFuente: '',

                };
                this.modalIni = false;
                this.fechaInicio = '';

                this.modalFin = false;
                this.fechaFin = '';

                this.fecIn = true;
                this.minDate = '';

                this.showBusqueda = false;
            }, 10);
        },
        ruleNumber: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57)) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
    },
    async mounted() {

        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "208"//modulo de quejas
        ).then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });

        Quejas.obtenerDepartamento(this);
        Quejas.obtenerListadoEstado(this);

        Quejas.obtenerFuenteQueja(this);
    }
}

</script>